import React from 'react';
import PropTypes from 'prop-types';
import { isType, flattenChildren } from '../../../../utils/react-children-utils/react-children-utils';

const PhoneNumberInput = function PhoneNumberInput(props) {
    const {
        placeholder,
        children,
        validation,
        invalidclass,
    } = props;

    const input = flattenChildren(children).find((c) => isType(c, 'input'));

    const newInput = React.cloneElement(
        input,
        {
            placeholder,
            'data-testid': `${input.props.name}-input`,
            onInput: (event) => {
                const { required } = props;
                const { value } = event.target;

                const phoneNumberRegex = /^[\d\s-]+$/;
                const noSpace = !value ? '' : value.replace(/[\s-]/g, '');

                // if required - always check the value
                const requiredCheck = required
                    && (noSpace.length !== 10 || !phoneNumberRegex.test(value));
                // if !required - only check if there is a value
                const notRequiredCheck = !required && value
                    && (noSpace.length !== 10 || !phoneNumberRegex.test(value));

                const error = requiredCheck || notRequiredCheck
                    ? 'Please provide a valid Contact Number'
                    : '';

                if (validation) {
                    validation(event, error);
                }
            },
            className: `${input.props.className} ${invalidclass}`,
        },
    );

    return newInput;
};

PhoneNumberInput.propTypes = {
    children: PropTypes.node.isRequired,
    validation: PropTypes.func,
    placeholder: PropTypes.string,
    invalidclass: PropTypes.string,
    required: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
};

PhoneNumberInput.defaultProps = {
    validation: () => { },
    placeholder: '',
    invalidclass: '',
    required: false,
};

export default PhoneNumberInput;
